export const projects = [
  {
    title: "Tennis Events",
    subtitle: "Google API and Nightmare.js",
    description:
      "Tennis Events is an app that allows a user to subscribe to a Google Calendar of ATP and WTA tennis events.",
    image: "./project-1.gif",
    link: "https://tennis-events.herokuapp.com",
  },
  {
    title: "chaa-ching",
    subtitle: "MERN Stack and Plaid API",
    description:
      "Chaa-ching is an app that allows you to connect all of your financial organizations in one place. You can view all of your transactions, create budgets and make savings goals all form the convenience of one app.",
    image: "./project-2.gif",
    link: "https://www.chaa-ching.app",
  },
  {
    title: "Live Chat",
    subtitle: "React and AWS Amplify",
    description:
      "Live Chat is a progressive web app that allows you to send and receive messages in real-time",
    image: "./project-3.gif",
    link: "https://main.d2hg3fs4j3hz86.amplifyapp.com",
  },
  {
    title: "To-Do List",
    subtitle: "React Hooks",
    description:
      "A progressive web app that allows a user to add, complete, incomplete and delete tasks",
    image: "./project-4.gif",
    link: "https://reacthooks-to-do-list.netlify.app/",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "JavaScript",
  "React",
  "Redux",
  "Nightmare.js",
  "Node",
  "MongoDB",
  "Material UI",
  "PostgriSQL",
  "Google APIs",
  "Bootsrap",
  "Tailwind CSS",
  "Express"
];



// WEBPACK FOOTER //
// ./src/data.js